export default function calculatePercentage(data) {
  const completed = data.reduce((total, user) => total + user.completed_themes, 0);
  const total = data.reduce((total, user) => total + user.total_themes, 0);

  const percentage = total === 0
    ? 0
    : completed * 100 / total;

  return Math.min(100, percentage).toFixed(2);
}
